import { Directive, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[clickOutside]'
})
export class ClickOutsideDirective implements OnDestroy {
  private unlisten!: () => void;
  @Output('clickOutside') clickOutside = new EventEmitter<MouseEvent>();
  @Input() exclude: string = '';

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.unlisten = this.renderer.listen('document', 'click', (event: MouseEvent) => this.onClick(event));
  }

  private onClick(event: MouseEvent): void {
    const targetElement = event.target;
    if (!(targetElement instanceof HTMLElement) || !targetElement.isConnected) return;
    const isOutside = !this.elementRef.nativeElement.contains(targetElement);
    const isExcluded = this.isElementExcluded(targetElement);

    if (isOutside && !isExcluded) {
      this.clickOutside.emit(event);
    }
  }

  private isElementExcluded(target: HTMLElement): boolean {
    if (!target) return false;
    if (this.elementRef.nativeElement.contains(target)) return true;
    if (this.exclude) {
      const selectors = this.exclude.split(',').map(s => s.trim()).filter(Boolean);
      if (target.closest(selectors.join(','))) return true;
      return selectors.some(sel => Array.from(document.querySelectorAll(sel))
        .some(el => el === target || el.contains(target)));
    }
    return false;
  }

  ngOnDestroy(): void {
    this.unlisten?.();
  }
}

export const dialogExcludeSelectors = [
  '.cdk-overlay-container',
  '.mat-datepicker-content',
  '.owl-dt-container',
  'ngx-mat-timepicker-standalone',
  '.ngx-mat-timepicker-content',
  '.timepicker',
  'ngx-mat-timepicker-face',
  '.clock-face',
  '.clock-face__number',
  '.mat-calendar-body-cell-content',
  '.mat-select-search-clear',
  '.grid-settings-flyout',
  '.cdk-overlay-pane',
  '.settings-switcher',
  '.reset-filters-btn',
  'button'
];